(function() { window.GUID_3fd42367_1fd9_4726_9f38_b877f89dcb4a = { getGuid: function() { return "3fd42367-1fd9-4726-9f38-b877f89dcb4a"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class ByesHelper {
            static getByesSequence($bracket) {
                let byesSequence = $bracket.find('.is-seedable.bye');
                let byesArray = byesSequence.toArray();
                byesArray.sort((bye1, bye2) => {
                    let byeIndex1 = $(bye1).data('byeindex');
                    let byeIndex2 = $(bye2).data('byeindex');
                    if (byeIndex1 < byeIndex2) {
                        return -1;
                    }
                    else if (byeIndex1 > byeIndex2) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
                return byesArray;
            }
            static FindBestOpponentToReplace($bracket) {
                let byesSeq = this.getByesSequence($bracket);
                if (byesSeq.length > 0) {
                    return $(byesSeq[0]);
                }
                else {
                    return null;
                }
            }
            static ShowAllSpotsWithOrder($bracket) {
                this.ClearDisplayedSpots($bracket);
                const byesSeq = this.getByesSequence($bracket);
                let indexes = "", matchNumbers = "", index = 1;
                $.each(byesSeq, function (i, element) {
                    let $bye = $(element);
                    if (index > 1) {
                        indexes += ",";
                        matchNumbers += ",";
                    }
                    const byeIndex = $bye.data("byeindex");
                    const $encounter = $bye.closest(".enc");
                    const matchNumber = $encounter.data("mn");
                    matchNumbers += matchNumber;
                    indexes += byeIndex;
                    $bye.addClass('bye-to-replace');
                    $bye.append('<div class="bye-to-replace-ind"><div>' + index + ' / ' + byesSeq.length + '</div></div>');
                    index += 1;
                });
                let $best = $(byesSeq[0]);
                $best.addClass('best-choice');
                const data = {
                    indexes,
                    matchNumbers
                };
                //Controls.Popup.ShowAjaxModal(Url.CSUrl("QuickTournamentShowSuggestedByesPopup"), data,
                //    (popup) => {
                //        // Popup loaded
                //        qtBracket.Bracket.ClearSelectedEncounter();
                //        let $lastByeSelected: JQuery;
                //        Controls.DropDown.Events.ListItemClicked({
                //            selector: "#dropdown-qt-replace-bye-with-opponent",
                //            callback: (list, e) => {
                //                qtBracket.Bracket.ClearSelectedEncounter();
                //                const byeIndex = e.data.value;
                //                const $bye = $(`[data-byeindex="${byeIndex}"]`);
                //                if ($bye.length) {
                //                    byesSeq.forEach((element, index) => {
                //                        $(element).removeClass("highlighted-bye");
                //                    });
                //                    $bye.addClass("highlighted-bye");
                //                    $lastByeSelected = $bye;
                //                    const $enc = $bye.closest(".enc");
                //                    if ($enc.length) {
                //                        qtBracket.Bracket.HighlightMatch($enc);
                //                        qtBracket.Bracket.$Bracket.addClass("suggested-bye-highlighted");
                //                        qtBracket.Bracket.ScrollToMatch($enc, false);
                //                    }
                //                }
                //                const $replaceByeButton = $("#button-qt-replace-bye-with-opponent");
                //                if ($replaceByeButton.length) {
                //                    $replaceByeButton.removeClass("disabled");
                //                }
                //            }
                //        });
                //        if (byesSeq.length == 1) {
                //            const dropdown = Controls.GetInstance(Controls.DropDown, "#dropdown-qt-replace-bye-with-opponent", true);
                //            console.log(dropdown);
                //            if (dropdown != null) {
                //                if (dropdown.$SelectableItems.length) {
                //                    Lag("QuickTournamentShowSuggestedByesPopup", 50, () => {
                //                        dropdown.$SelectableItems.first().trigger("click");
                //                    });
                //                }
                //            }
                //        }
                //        popup.$Control.offon("click.QuickTournamentShowSuggestedByesPopup", "#button-qt-replace-bye-with-opponent", (e) => {
                //            if ($lastByeSelected != null && $lastByeSelected.length) {
                //                ReplaceOpponent.ShowFromSuggestedByeSelection(qtBracket, $lastByeSelected, () => {
                //                    popup.Close();
                //                });
                //            }
                //        });
                //    },
                //    () => {
                //        // Popup closed
                //        this.ClearDisplayedSpots(qtBracket);
                //    }, false, true, true);
            }
            static ClearDisplayedSpots($bracket) {
                let $spots = $bracket.find('.bye-to-replace');
                let $ind = $spots.find('.bye-to-replace-ind');
                $ind.remove();
                $spots.removeClass("bye-to-replace");
                $bracket.removeClass("suggested-bye-highlighted");
            }
        }
        Views.ByesHelper = ByesHelper;
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=byes-helper.js.map
